export default "__VITE_ASSET__76e1d350__"